export enum AdjustTrackEvent {
  EPISODE_PUBLISHED = '9x0toq',
  EPISODE_PUBLISHED_UNIQUE = '5rxm1w',
  ONBOARDING_COMPLETED = 'o3apzr',
  ONBOARDING_COMPLETED_UNIQUE = 'cqy8uk',
  ONBOARDING_STARTED = 'w9h85q',
}
